var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('WebsiteHeader'),_c('router-view',{staticStyle:{"margin-top":"100px","padding":"0 20px","min-height":"calc(100vh - 230px)"}}),_c('WebsiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }